import React from 'react'

export default function FromRadioOption({value, onChangeFunc}) {

  const handleChange = ()=>{
    onChangeFunc({value});
  }
  return (
    <div className='radio-option'>
      <label className = "radio-label" htmlFor = {value}>
        <input type = "radio" name ="writing Style" value = {value} onChange={handleChange}/>
        {value}
      </label>
    </div>
  )
}

